import React from 'react';
import {Table, TableBody, TableCell, TableHead, TableRow} from '@bosch/react-frok';
import {ContentWrapper} from './ItemTable.style';
import {ItemTableRow} from './ItemTableRow';
import {t} from 'i18next';
import {ItemProps} from '../ItemProps';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import {isVisibleComponent} from '../../../utils/TemplateUtils';
import {
    ITEMS_HEADER_LAYOUT_TABLE_BODY,
    ITEMS_HEADER_LAYOUT_TABLE_HEAD,
    ITEMS_HEADER_MOBILE_LAYOUT_TABLE_BODY,
    ITEMS_HEADER_MOBILE_LAYOUT_TABLE_HEAD,
    ITEMS_VIEW_COMMAND_ACTION,
    ITEMS_VIEW_DATE_CREATED,
    ITEMS_VIEW_FILE_TYPE,
    ITEMS_VIEW_MOBILE_DATE_CREATED,
    ITEMS_VIEW_MOBILE_FILE_TYPE,
    ITEMS_VIEW_MOBILE_NAME,
    ITEMS_VIEW_MOBILE_PUBLIC_ACCESS,
    ITEMS_VIEW_MOBILE_THUMBNAIL,
    ITEMS_VIEW_MOBILE_TOTAL_SIZE,
    ITEMS_VIEW_NAME,
    ITEMS_VIEW_PUBLIC_ACCESS,
    ITEMS_VIEW_THUMBNAIL,
    ITEMS_VIEW_TOTAL_SIZE
} from '../../../init/ui_component_constants';

/**
 * @name ItemTable
 * @description
 * Component to show a download item (folder/file) for the table visualisation.
 */
export const ItemTable: React.VFC<ItemProps> = (props) => {
    return (
        <ContentWrapper id={generateIdentifier()}>
            <Table id={generateIdentifier()}>
                <TableHead id={generateIdentifier()}
                           hidden={!(isVisibleComponent(ITEMS_HEADER_LAYOUT_TABLE_HEAD, props.templatePropertySettings)
                               && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(ITEMS_HEADER_MOBILE_LAYOUT_TABLE_HEAD, props.templatePropertySettings))))}>
                    <TableRow id={generateIdentifier()}>
                        <TableCell id={generateIdentifier()}
                                   hidden={!(isVisibleComponent(ITEMS_VIEW_THUMBNAIL, props.templatePropertySettings)
                                       && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(ITEMS_VIEW_MOBILE_THUMBNAIL, props.templatePropertySettings))))}
                                   header secondary></TableCell>
                        <TableCell id={generateIdentifier()}
                                   hidden={!(isVisibleComponent(ITEMS_VIEW_NAME, props.templatePropertySettings)
                                       && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(ITEMS_VIEW_MOBILE_NAME, props.templatePropertySettings))))}
                                   header secondary>
                            {t('ITEM_VISUALISATION_TITLE_HEADLINE')}
                        </TableCell>
                        <TableCell id={generateIdentifier()}
                                   hidden={!(isVisibleComponent(ITEMS_VIEW_FILE_TYPE, props.templatePropertySettings)
                                       && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(ITEMS_VIEW_MOBILE_FILE_TYPE, props.templatePropertySettings))))}
                                   header
                                   secondary>
                            {t('ITEM_VISUALISATION_FILE_TYPE_HEADLINE')}
                        </TableCell>
                        <TableCell id={generateIdentifier()}
                                   hidden={!(isVisibleComponent(ITEMS_VIEW_DATE_CREATED, props.templatePropertySettings)
                                       && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(ITEMS_VIEW_MOBILE_DATE_CREATED, props.templatePropertySettings))))}
                                   header secondary>
                            {t('ITEM_VISUALISATION_UPLOAD_HEADLINE')}
                        </TableCell>
                        <TableCell id={generateIdentifier()}
                                   hidden={!(isVisibleComponent(ITEMS_VIEW_TOTAL_SIZE, props.templatePropertySettings)
                                       && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(ITEMS_VIEW_MOBILE_TOTAL_SIZE, props.templatePropertySettings))))}
                                   header secondary>
                            {t('ITEM_VISUALISATION_FILE_SIZE_HEADLINE')}
                        </TableCell>
                        <TableCell id={generateIdentifier()}
                                   hidden={!(props.editMode && (isVisibleComponent(ITEMS_VIEW_PUBLIC_ACCESS, props.templatePropertySettings)
                                       && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(ITEMS_VIEW_MOBILE_PUBLIC_ACCESS, props.templatePropertySettings)))))}
                                   header secondary>
                            {props.editMode && t('PUBLIC_ACCESS')}
                        </TableCell>
                        <TableCell id={generateIdentifier()}
                                   hidden={!isVisibleComponent(ITEMS_VIEW_COMMAND_ACTION, props.templatePropertySettings)}
                                   header secondary></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody id={generateIdentifier()}
                           hidden={!(isVisibleComponent(ITEMS_HEADER_LAYOUT_TABLE_BODY, props.templatePropertySettings)
                               && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(ITEMS_HEADER_MOBILE_LAYOUT_TABLE_BODY, props.templatePropertySettings))))}>
                    {props.items.map(item => (
                        <ItemTableRow key={item.id}
                                      isMobileView={props.isMobileView}
                                      isMobileResolution={props.isMobileResolution}
                                      layoutView={props.layoutView}
                                      item={item}
                                      language={props.language}
                                      defaultLocale={props.defaultLocale}
                                      editMode={props.editMode}
                                      publicOnlyAccess={props.publicOnlyAccess}
                                      isFavorite={props.favoriteItems.includes(item.id)}
                                      labelData={props.labelData ?? []}
                                      onEdit={() => props.onEdit(item)}
                                      onDelete={() => props.onDelete(item)}
                                      onDownload={() => props.onDownload(item)}
                                      onDetails={() => props.onDetails(item)}
                                      onFavorite={() => props.onFavorite(item)}
                                      onPreview={() => props.onPreview(item)}
                                      onCopyUrl={() => props.onCopyUrl(item)}
                                      onClick={() => props.onClick(item)}/>
                    ))}
                </TableBody>
            </Table>
        </ContentWrapper>
    );
};
